import Api from "@/services/Api";


export default {
  getCaptcha() {
    return Api().post("/get-captcha");
  },
  signUp (params) {
    return Api().post("signup-user", params);
  },

  logIn (params) {
    return Api().post("login", params);
  },

  signUpByAdmin (params, token) {
    return Api().post("/signup-by-admin", params, {
      headers: { "x-access-token": token }
    });
  },

  updateUserDMAPassword (params, token) {
    return Api().post("/update-user-dma", params, {
      headers: { "x-access-token": token }
    });
  },
  fetchProfile (params, token) {
    return Api().post("/profile", params, {
      headers: { "x-access-token": token }
    });
  },
  resendEmail (params) {
    return Api().post("/resend-email", params);
  },
  confirmation (params) {
    return Api().post("/confirmation", params);
  }
};
